// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subfooter-btn[data-v-98c43932]{width:130px;font-size:12px!important}.subfooter-btn-mobile[data-v-98c43932]{width:100px}.subfooter-link[data-v-98c43932]{color:#d3d3d3}", ""]);
// Exports
module.exports = exports;
